import ProductCard from "components/General/ProductCard/ProductCard";

const RelatedProducts = ({ relatedProducts }) => {
  return (
    <section className="px-4 mx-auto mb-16 xl:px-0 max-w-app">
      <h2>Gerelateerde producten</h2>
      <div className="grid grid-cols-2 gap-x-6 gap-y-9 sm:gap-10 lg:grid-cols-3 2xl:grid-cols-4">
        {relatedProducts?.map((product, idx) => {
          return <ProductCard product={product} key={idx} />;
        })}
      </div>
    </section>
  );
}

export default RelatedProducts;